import { render, staticRenderFns } from "./tabsBox.vue?vue&type=template&id=1e302d94&scoped=true&lang=html&"
import script from "./tabsBox.vue?vue&type=script&lang=js&"
export * from "./tabsBox.vue?vue&type=script&lang=js&"
import style0 from "./tabsBox.vue?vue&type=style&index=0&id=1e302d94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e302d94",
  null
  
)

export default component.exports